import { describe, expect, it } from "vitest";

import { splitHtmlLines, parseLineHighlights } from "./syntax-highlighter";

describe("splitHtmlLines", () => {
  it("splits plain text with no spans", () => {
    expect(splitHtmlLines("hello\nworld")).toEqual(["hello", "world"]);
  });

  it("repairs a span crossing a line boundary", () => {
    const html = '<span class="a">hello\nworld</span>';
    expect(splitHtmlLines(html)).toEqual([
      '<span class="a">hello</span>',
      '<span class="a">world</span>',
    ]);
  });

  it("handles close then open on the same line", () => {
    const html =
      '<span class="a">first\n</span><span class="b">second\nthird</span>';
    const result = splitHtmlLines(html);

    // Line 1: carries nothing, opens "a" → "first" with closing tag
    expect(result[0]).toBe('<span class="a">first</span>');
    // Line 2: carries "a", raw line closes "a" then opens "b" → only "b" open
    expect(result[1]).toBe(
      '<span class="a"></span><span class="b">second</span>',
    );
    // Line 3: carries only "b"
    expect(result[2]).toBe('<span class="b">third</span>');
  });

  it("re-opens nested spans crossing lines", () => {
    const html = '<span class="a"><span class="b">text\nmore</span></span>';
    const result = splitHtmlLines(html);
    expect(result[0]).toBe(
      '<span class="a"><span class="b">text</span></span>',
    );
    expect(result[1]).toBe(
      '<span class="a"><span class="b">more</span></span>',
    );
  });

  it("preserves empty lines", () => {
    expect(splitHtmlLines("line1\n\nline3")).toEqual(["line1", "", "line3"]);
  });

  it("does not carry forward complete spans on one line", () => {
    const html = '<span class="a">x</span><span class="b">y</span>\nnext';
    expect(splitHtmlLines(html)).toEqual([
      '<span class="a">x</span><span class="b">y</span>',
      "next",
    ]);
  });

  it("handles a single line with no newlines", () => {
    expect(splitHtmlLines('<span class="a">hello</span>')).toEqual([
      '<span class="a">hello</span>',
    ]);
  });
});

describe("parseLineHighlights", () => {
  it("returns empty highlights when no meta is provided", () => {
    expect(parseLineHighlights("javascript")).toEqual({
      lang: "javascript",
      highlights: {},
    });
  });

  it("parses addition ranges", () => {
    const result = parseLineHighlights("js", 'highlight="+1-3"');
    expect(result.highlights).toEqual({
      1: "addition",
      2: "addition",
      3: "addition",
    });
  });

  it("parses removal lines", () => {
    const result = parseLineHighlights("js", 'highlight="-5"');
    expect(result.highlights).toEqual({ 5: "removal" });
  });

  it("parses neutral highlight lines", () => {
    const result = parseLineHighlights("js", 'highlight="7"');
    expect(result.highlights).toEqual({ 7: "highlight" });
  });

  it("parses mixed specs", () => {
    const result = parseLineHighlights("js", 'highlight="+1-3,-5,7"');
    expect(result.highlights).toEqual({
      1: "addition",
      2: "addition",
      3: "addition",
      5: "removal",
      7: "highlight",
    });
  });
});
